import React from 'react';
import PropTypes from 'prop-types';
import { List, makeStyles, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { ListTableNavigation } from '~/modules/common/components/ListTable/components/DataTable/components';
import PageOutOfBoundsMessage from '~/modules/common/components/ListTable/PageOutOfBoundsMessage';
import RoleSelectionRow from './RoleSelectionRow';

const useStyles = makeStyles(theme => ({
  list: {
    maxHeight: 240,
    overflowY: 'auto'
  },
  emptyText: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 0)
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(0.5)
  }
}));

const PaginatedRoleSelectionList = ({
  rows,
  recordCount,
  currentPage,
  setCurrentPage,
  pageSize,
  isRoleChecked,
  defaultRole,
  onToggle,
  onSetDefault,
  emptyMessageId
}) => {
  const classes = useStyles();

  return (
    <>
      {(rows.length > 0 || currentPage > 1) && (
        <div className={classes.pagination}>
          <ListTableNavigation
            currentPage={currentPage}
            navigatePage={setCurrentPage}
            pageSize={pageSize}
            recordCount={recordCount}
          />
        </div>
      )}
      {recordCount === 0 && currentPage > 1 ? (
        <PageOutOfBoundsMessage
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      ) : (
        <List disablePadding className={classes.list}>
          {rows.length === 0 && emptyMessageId ? (
            <Typography className={classes.emptyText}>
              <FormattedMessage id={emptyMessageId} />
            </Typography>
          ) : (
            rows.map(role => (
              <RoleSelectionRow
                key={role.roleUri}
                roleUri={role.roleUri}
                displayText={role.displayText}
                isAssigned={role.isAssigned}
                isChecked={isRoleChecked(role)}
                isDefault={role.roleUri === defaultRole?.id}
                onToggle={onToggle}
                onSetDefault={onSetDefault}
              />
            ))
          )}
        </List>
      )}
    </>
  );
};

PaginatedRoleSelectionList.propTypes = {
  rows: PropTypes.array.isRequired,
  recordCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  isRoleChecked: PropTypes.func.isRequired,
  defaultRole: PropTypes.shape({
    id: PropTypes.string,
    displayText: PropTypes.string
  }),
  onToggle: PropTypes.func.isRequired,
  onSetDefault: PropTypes.func.isRequired,
  emptyMessageId: PropTypes.string
};

export default PaginatedRoleSelectionList;
